import IllumioSupportForm from "../common/support_form.js";
import IllumioSupportUtils from "../common/support_utils.js";

export const IloToolDownloadForm = {
    initialize: function() {
        // Initialize Download button
        // $('form.download-tool-form input[name="download"]').click(IloToolDownloadForm.submitButtonClickHandler);
        const downloadButtons = document.querySelectorAll('form.download-tool-form input[name="download"]');
        for (const downloadButton of downloadButtons) {
            downloadButton.onclick = IloToolDownloadForm.submitButtonClickHandler;
            downloadButton.form['authenticity_token'].value = IllumioSupportForm.getCsrf(false);
        }

        // Initialize EULA input
        // $('input#eulaInput').click(IloToolDownloadForm.eulaInputOnClickHandler);
        const eulaInput = document.querySelector('input#eulaInput');
        if (eulaInput) {
            eulaInput.onclick = IloToolDownloadForm.eulaInputOnClickHandler;
        }
    },
    eulaInputOnClickHandler: function(event) {
        const $eulaAcceptance = $('input[name="eula_acceptance"]');
        const $downloadButtons = $('input[name="download"]');
        let isChecked = (event.currentTarget && event.currentTarget.checked==true) ? true : false;
        $eulaAcceptance.val(isChecked);
    },
    submitButtonClickHandler: function(event) {
        IloToolsModal.currentForm = event.currentTarget.form;
        const eulaModal = document.getElementById('eulaModal');
        eulaModal.show();
    }, 
}

export const IloToolsModal = {
    currentForm: null, 
    initialize: function() {
        // $('a#eulaAcceptanceContinueButtonLink').click(IloToolsModal.downloadButtonClickHandler);
        const eulaAcceptanceButton = document.querySelector('a#eulaAcceptanceContinueButtonLink');
        if (eulaAcceptanceButton) {
            eulaAcceptanceButton.onclick = IloToolsModal.downloadButtonClickHandler;
        }
    },
    downloadButtonClickHandler: function(event) {
        const eulaInput = document.getElementById('eulaInput');
        const eulaErrorMessage = document.getElementById('eulaErrorMessage');
        if (eulaInput && eulaInput.checked==true && IloToolsModal.currentForm) {
            if (eulaErrorMessage) {
                eulaErrorMessage.classList.add('hidden');
            }
            IllumioSupportUtils.trackGaEvent('Tools', 'download', document.title); 
            IloToolsModal.currentForm.submit();
            IloToolsModal.currentForm = null;
            const eulaModal = document.getElementById('eulaModal');
            eulaModal.close();
        } else { 
            if (eulaErrorMessage) {
                eulaErrorMessage.classList.remove('hidden');
                eulaErrorMessage.style.color = '#f00';
            }
            eulaInput.style.color = '#f00';
        }
        return false;
    }
}

export const IloToolsFeedbackForm = {
    isDebug: true, 
    initialize: function() {
        const theFeedbackForm = document.getElementById('theFeedbackForm');
        if (theFeedbackForm) {
            theFeedbackForm['authenticity_token'].value = IllumioSupportForm.getCsrf(false);
            theFeedbackForm.onsubmit = IloToolsFeedbackForm.submitHandler;
        }
    },
    submitHandler: function(event) {
        const theForm = event.target;
        
        if (!theForm) {
            return false;
        }
        
        const $theSubmitButton = $('#'+theForm.id+' input[type="submit"]');
        const beforeSendHandler = function() {
            $theSubmitButton.attr('disabled', true);
            const feedbackRating = document.getElementById('feedbackRating');
            feedbackRating.classList.remove('missing');
            const theError = document.getElementById('feedbackRatingError');
            theError.classList.add('hidden');
        };
        const successHandler = function(data, textStatus, jqXHR) {
            if (IloToolsFeedbackForm.isDebug) {
                console.debug(data);
                console.debug(textStatus);
                console.debug(jqXHR);
            }
            if (textStatus=='success' && data) {
                if (data.status=='success' || data.status=='queued') {
                    theForm.reset();
                    const feedbackResponseModal = document.getElementById('feedbackResponseModal');
                    feedbackResponseModal.show();
                } else if (data.status=='validation') {
                    if (data.status.description) {
                        for (let key in data.status.description) {
                            if (data.status.description[key]=='score') {
                                const theError = document.getElementById('feedbackRatingError');
                                theError.classList.remove('hidden');
                                const feedbackRating = document.getElementById('feedbackRating');
                                feedbackRating.classList.add('missing');
                            }
                        }
                    }
                }
            }
        };
        const errorHandler = function(jqXHR, textStatus, errorThrown) {
            if (IloToolsFeedbackForm.isDebug) {
                console.debug('Status: ' + textStatus);
                console.debug('errorThrown: ' + errorThrown);
                console.debug(jqXHR); 
            }
        };
        const completeHandler = function(jqXHR, textStatus) {
            if (IloToolsFeedbackForm.isDebug) {
                console.debug('Status: ' + textStatus);
                console.debug(jqXHR); 
            }
            $theSubmitButton.attr('disabled', false);
        };
        
        $.ajax({
            dataType: 'json', 
            type: "POST", 
            url: '/feedback', 
            data: jQuery(theForm).serialize(), 
            beforeSend: beforeSendHandler, 
            success: successHandler, 
            error: errorHandler, 
            complete: completeHandler, 
        });
        
        return false;
    }, 
}

export const IloToolsFeedbackSubmitModal = {
    initialize: function() {
        const feedbackSuccessCloseButton = document.querySelector('a#toolsFeedbackSuccessCloseButton');
        if (feedbackSuccessCloseButton) {
            feedbackSuccessCloseButton.onclick = IloToolsFeedbackSubmitModal.onclickHandler;
        }
    },
    onclickHandler: function(event) {
        console.debug(event);
        const feedbackResponseModal = document.getElementById('feedbackResponseModal');
        feedbackResponseModal.close();
        return false;
    }, 
}
